import { AppDispatch, GetState, RootState } from '../store';
import { changeStep, Step } from '../slices/step.slice';
import { isPersonaInformationPrefilled } from './init-current-step';

export const completePhoneNumberVerification = () => {
	return (dispatch: AppDispatch, getState: GetState): void => {
		const nextStep = determineNextStep(getState());
		dispatch(changeStep(nextStep));
	};
};

function determineNextStep(state: RootState): Step {
	return isPersonaInformationPrefilled(state) ? 'PERSONA_CONSENT_INPUT_STEP' : 'PERSONA_INFORMATION_INPUT_STEP';
}
